import { ContentBlock } from "../../types/contentBlock";
import { TextBlock } from "../../types/textBlock";

export const textBlockQuery = `
    _type == "textBlock" => {
        _type,
        _key,
        title[] {
            ...,
            markDefs[] {
                ...,
                _type == "internalLink" => {
                    "link": @.reference->title
                }
            }
        },
        text,
        type,
        link {
            _type,
            label,
            type,
            internal-> {
                _id,
                metadata {
                    slug
                }
            },
            external -> {
                _id,
                metadata {
                    slug
                }
            }
        },
        spacing,
        customSpacingTop,
        customSpacingBottom,
        position
    }
`

export const isTextBlock = (block: ContentBlock): block is TextBlock => {
    return block._type === 'textBlock';
}

